export default __webpack_public_path__ + "static/media/instagram.d2118c04.svg";